import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import { EventNotifyModal } from "./EventNotifyModal";
//import { EventToast } from "./Toast";
import {
	DataGrid,
	GridColDef,
	GridToolbarContainer,
	GridToolbarExport,
	GridRenderCellParams,
	GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUtensils } from "@fortawesome/free-solid-svg-icons";
import "./EventAttendees.css";

const columns: GridColDef[] = [
	{ field: "surname", headerName: "Surname", width: 120 },
	{ field: "given_name", headerName: "Given Name", width: 120 },
	{
		field: "compass_group",
		headerName: "Compass",
		width: 150,
		editable: false,
	},
	{
		field: "boarder",
		headerName: "Boarder",
		width: 20,
		editable: false,
		renderCell: (params: GridRenderCellParams<string>) => {
			if (params.value) {
				return (
					<svg
						className="going MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiDataGrid-booleanCell css-ptiqhd-MuiSvgIcon-root"
						focusable="false"
						role="img"
						viewBox="0 0 24 24"
						data-testid="CheckIcon"
						data-value="true"
					>
						<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
						<title>Boarder</title>
					</svg>
				);
			} else {
				return <i>&nbsp;</i>;
			}
		},
	},
	{
		field: "EdumateStudentNumber",
		headerName: "Stud No",
		width: 70,
		renderCell: (params: GridRenderCellParams<string>) => (
			<a
				href={`https://edumate.pymblelc.nsw.edu.au/pymble/web/app.php/admin/search-result/#contact/${params.value}`}
				tabIndex={params.tabIndex}
				target={`_blank`}
			>
				{params.value}
			</a>
		),
	},
	{ field: "carer1", headerName: "Carer 1", flex: 1 },
	{
		field: "carer1_phone",
		headerName: "Phone",
		width: 110,
		renderCell: (params: GridRenderCellParams<string>) => (
			<a
				href={`tel:${params.value}`}
				tabIndex={params.tabIndex}
				target={`_blank`}
			>
				{params.value}
			</a>
		),
	},
	{
		field: "carer1_email",
		headerName: "Email",
		flex: 1,
		renderCell: (params: GridRenderCellParams<string>) => (
			<a
				href={`mailto:${params.value}`}
				tabIndex={params.tabIndex}
				target={`_blank`}
			>
				{params.value}
			</a>
		),
	},
	{ field: "carer2", headerName: "Carer 2", flex: 1 },
	{
		field: "carer2_phone",
		headerName: "Phone",
		width: 110,
		renderCell: (params: GridRenderCellParams<string>) => (
			<a
				href={`tel:${params.value}`}
				tabIndex={params.tabIndex}
				target={`_blank`}
			>
				{params.value}
			</a>
		),
	},
	{
		field: "carer2_email",
		headerName: "Email",
		flex: 1,
		renderCell: (params: GridRenderCellParams<string>) => (
			<a
				href={`mailto:${params.value}`}
				tabIndex={params.tabIndex}
				target={`_blank`}
			>
				{params.value}
			</a>
		),
	},
	{
		field: "approval",
		headerName: "Approved",
		width: 80,
		type: "singleSelect",
		valueOptions: ["Not Provided", "Approved", "Not Approved"],
		editable: true,
		align: "center",
		renderCell: (params: GridRenderCellParams<string>) => {
			if (
				params.value?.toLowerCase() === "approved" ||
				params.value?.toLowerCase() === "going"
			) {
				return (
					<svg
						className="going MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiDataGrid-booleanCell css-ptiqhd-MuiSvgIcon-root"
						focusable="false"
						role="img"
						viewBox="0 0 24 24"
						data-testid="CheckIcon"
						data-value="true"
					>
						<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
						<title>Approved</title>
					</svg>
				);
			} else if (
				params.value?.toLowerCase() === "not going" ||
				params.value?.toLowerCase() === "not approved"
			) {
				return (
					<svg
						className="not-going MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiDataGrid-booleanCell css-ptiqhd-MuiSvgIcon-root"
						focusable="false"
						role="img"
						viewBox="0 0 24 24"
						data-testid="CloseIcon"
						data-value="false"
					>
						<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
						<title>Not Approved</title>
					</svg>
				);
			} else {
				return <i>&nbsp;</i>;
			}
		},
	},
	{
		field: "approval_time",
		headerName: "Time Approved",
		width: 130,
		align: "center",
	},
	// {
	// 	field: "form",
	// 	headerName: "Form",
	// 	width: 50,
	// 	type: "boolean",
	// 	editable: true,
	// 	align: "center",
	// 	renderCell: (params: GridRenderCellParams<String>) => {
	// 		return params.value ? (
	// 			<svg
	// 				className="going MuiSvgIcon-root MuiSvgIcon-fontSizeSmall MuiDataGrid-booleanCell css-ptiqhd-MuiSvgIcon-root"
	// 				focusable="false"
	// 				role="img"
	// 				viewBox="0 0 24 24"
	// 				data-testid="CheckIcon"
	// 				data-value="true"
	// 			>
	// 				<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
	// 				<title>yes</title>
	// 			</svg>
	// 		) : (
	// 			<i>&nbsp;</i>
	// 		);
	// 	},
	// },
	{
		field: "medical_form",
		headerName: "Medical",
		width: 70,
		align: "center",
		renderCell: (params: GridRenderCellParams<string>) => {
			return params.value ? (
				<a
					href={params.value.toString()}
					tabIndex={params.tabIndex}
					target={"_blank"}
					className="med-form"
				>
					{/* <svg
						className="med-form MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root"
						focusable="false"
						role="img"
						viewBox="0 0 24 24"
						data-testid="SaveAltIcon"
					>
						<path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"></path>
					</svg> */}
				</a>
			) : (
				<i>&nbsp;</i>
			);
		},
	},
	{
		field: "dietary",
		headerName: "Dietary",
		width: 70,
		align: "center",
		sortable: false,
		renderCell: (params: GridRenderCellParams<string>) =>
			params.value ? (
				<span title={params.value}>
					<FontAwesomeIcon icon={faUtensils} aria-label={params.value} />
				</span>
			) : (
				<i>&nbsp;</i>
			),
	},
];

type AttendeeData = {
	id: string;
	surname: string;
	given_name: string;
	boarder: boolean;
	compass_group: string;
	EdumateStudentNumber: string;
	carer1: string;
	carer1_email: string;
	carer1_phone: string;
	carer2: string;
	carer2_email: string;
	carer2_phone: string;
	approval: string;
	approval_time: string;
	form: boolean;
	medical_form: string;
	dietary: string;
};

type EventData = {
	_id: string;
	Title: string;
	EventId: number;
	EndDateTime: string;
	Attendees: AttendeeData[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ParentGroup: any[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	StartDateTime: any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ForeignKeys: any[];
};
interface EventAttendeeProps {
	initialData: EventData;
	onValueChange: (data: Approvals[]) => void;
	onFormValueChange: (data: FormSubmissions[]) => void;
	canEdit?: boolean;
}

type Approvals = {
	id: string;
	value: string;
};

type FormSubmissions = {
	id: string;
	value: string;
};

export const EventAttendees: React.FC<EventAttendeeProps> = ({
	initialData,
	onValueChange,
	onFormValueChange,
	canEdit = true,
}) => {
	const eventData = initialData;
	const [attendees, setAttendees] = useState<AttendeeData[]>([]);
	const attendeeRows = attendees;
	const dietaryRows = attendeeRows.filter((a) => a.dietary);

	// Dietary requirements (csv): only attendees who have a requirement.
	const handleDownloadDietary = () => {
		// Quote every cell and defuse spreadsheet formulas.
		const cell = (v: string) => {
			const safe = /^[=+\-@\t\r]/.test(v) ? "'" + v : v;
			return '"' + safe.replace(/"/g, '""') + '"';
		};
		const header = ["Surname", "Given Name", "Student No", "Compass", "Dietary"];
		const lines = [header, ...dietaryRows.map((a) => [
			a.surname,
			a.given_name,
			a.EdumateStudentNumber,
			a.compass_group,
			a.dietary,
		])].map((r) => r.map((v) => cell(String(v ?? ""))).join(","));
		const blob = new Blob(["\ufeff" + lines.join("\r\n")], {
			type: "text/csv;charset=utf-8",
		});
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = "event-dietary-requirements.csv";
		link.click();
		URL.revokeObjectURL(url);
	};
	const [approvalArray, setApprovalArray] = useState<Approvals[]>([]);
	const [formArray, setFormArray] = useState<FormSubmissions[]>([]);
	const [reportButtonDisabled, setReportButtonDisabled] = useState(true);
	const [pdfMedical, setPdfMedical] = useState("");
	const [csvMedical, setCsvMedical] = useState("");
	const [showInteractionButtons, setShowInteractionButtons] = useState(false);
	const [showNotificationModal, setShowNotificationModal] = useState(false);
	// const [notificationTitle, setNotificationTitle] = useState("");
	// const [notificationBody, setNotificationBody] = useState("");
	const handleCloseNotificationModal = (data: boolean) => {
		setShowNotificationModal(data);
	};
	const handleShowNotificationModal = () => {
		if (showInteractionButtons) setShowNotificationModal(true);
	};

	// const handleSetNotificationTitle = (e: any) =>
	// 	setNotificationTitle(e.target.value);
	// const handleSetNotificationBody = (e: any) =>
	// 	setNotificationBody(e.target.value);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleEditCell = (e: any) => {
		if (e.field === "approval") {
			e.value = e.value === "Not Provided" ? "" : e.value;
			const newApproval: Approvals = { id: e.id, value: e.value };
			const elementIndex = approvalArray.findIndex(
				(element) => element.id === e.id
			);
			if (elementIndex !== -1) {
				const updatedArray = [...approvalArray];
				updatedArray[elementIndex] = {
					...approvalArray[elementIndex],
					value: e.value,
				};
				setApprovalArray(updatedArray);
			} else {
				setApprovalArray([...approvalArray, newApproval]);
			}
		} else {
			const newFormSubmissions: FormSubmissions = { id: e.id, value: e.value };
			const elementIndex = formArray.findIndex(
				(element) => element.id === e.id
			);

			if (elementIndex !== -1) {
				const updatedArray = [...formArray];
				updatedArray[elementIndex] = {
					...formArray[elementIndex],
					value: e.value,
				};
				setFormArray(updatedArray);
			} else {
				setFormArray([...formArray, newFormSubmissions]);
			}
		}
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleCreateNotice = (_e: any) => {
		const url =
			"https://notices.pymblelc.nsw.edu.au/notices?event_id=" +
			eventData._id +
			"&group_id=" +
			eventData.ParentGroup +
			"&title=" +
			eventData.Title;
		return window.open(url, "_blank");
	};

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleNotifySent = (val: any) => {
		setShowNotificationModal(val.show);
	};

	function CustomToolbar() {
		return (
			<GridToolbarContainer>
				<GridToolbarExport
					csvOptions={{
						fileName: "event-attendees-report",
					}}
				/>
				{/* @ts-expect-error MUI DataGrid v5 GridToolbarFilterButton type mismatch with @types/react 18.3+ */}
				<GridToolbarFilterButton />
			</GridToolbarContainer>
		);
	}

	function formatPhone(phone: string) {
		let formattedNumber = "";
		if (phone) {
			phone = phone.replace(/\D/g, "");
			// Format the phone number
			if (phone.length > 0) {
				if (phone.startsWith("04")) {
					// Mobile number formatting
					formattedNumber = phone.substring(0, 4);
					if (phone.length > 4) {
						formattedNumber += " " + phone.substring(4, 7);
						if (phone.length > 7) {
							formattedNumber += " " + phone.substring(7, 10);
						}
					}
				} else {
					// Landline number formatting
					formattedNumber = phone.substring(0, 4);
					if (phone.length > 2) {
						formattedNumber += " " + phone.substring(4, 10);
					}
				}
			}
		}
		return formattedNumber;
	}
	function enableInteractionButtons() {
		// check if the group still exists or the event has not happened yet
		// enable create notice and notify buttons
		console.log("Event data: ", eventData.EndDateTime);
		const datetime = new Date(eventData.EndDateTime);

		// Get the current date and time
		const currentDatetime = new Date();

		// Compare the datetime with the current datetime
		if (datetime >= currentDatetime) {
			setShowInteractionButtons(true);
		} else {
			setShowInteractionButtons(false);
		}
	}
	useEffect(() => {
		if (eventData) {
			const attendees: AttendeeData[] = initialData.Attendees;
			if (attendees) {
				//remove attendees that don't have a student number
				const filteredAttendees = attendees.filter(
					(attendee) => attendee.EdumateStudentNumber
				);

				let attendeeArray: AttendeeData[] = filteredAttendees.map(
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					(item: any) => {
						const name = item.Name.split(",");
						let carer1 = null;
						let carer2 = null;

						if (item.Carers.length > 0) {
							carer1 = item.Carers[0];
						}
						if (item.Carers.length > 1) {
							carer2 = item.Carers[1];
						}

						let datetime = new Date(initialData["StartDateTime"]);
						let edu_rep_day = datetime.getDate().toString().padStart(2, "0");
						let edu_rep_month = (datetime.getMonth() + 1)
							.toString()
							.padStart(2, "0");
						let edu_rep_year = datetime.getFullYear();

						let medForm =
							`https://edumate.pymblelc.nsw.edu.au/pymble4/pages/office/enrolments/generate_one_click_report.php` +
							`?modRepId=2713&modRepDisp=inline&modRepName=medical_report&module=General` +
							`&Event_Start_Date=${
								edu_rep_year + "-" + edu_rep_month + "-" + edu_rep_day
							}&Student_Number=${item.EdumateStudentNumber}&EventID=${
								initialData?.EventId
							}`;

						if (
							initialData["ForeignKeys"] &&
							initialData["ForeignKeys"].hasOwnProperty("Edumate")
						) {
							setPdfMedical(
								`https://edumate.pymblelc.nsw.edu.au/pymble4/pages/office/enrolments/generate_one_click_report.php` +
									`?modRepId=3179&modRepDisp=inline&modRepName=medical_report&module=General` +
									`&Student_Number=&EventID=${initialData?.EventId}`
							);

							setCsvMedical(
								`https://edumate.pymblelc.nsw.edu.au/pymble4/pages/office/enrolments/generate_one_click_report.php` +
									`?modRepId=3180&modRepDisp=attachment&module=General` +
									`&Student_Number=&EventID=${initialData?.EventId}`
							);
							setReportButtonDisabled(false);
						} else {
							setReportButtonDisabled(true);
						}

						return {
							id: item.id,
							surname: name[0],
							given_name: name[1],
							compass_group: item.CompassGroup,
							boarder:
								!item.Boarder || item.Boarder.indexOf("Day") > -1
									? false
									: true,
							EdumateStudentNumber: item.EdumateStudentNumber,
							carer1: carer1 ? carer1.Name : "",
							carer1_email: carer1 ? carer1.Email : "",
							carer1_phone:
								carer1 && carer1.Phone ? formatPhone(carer1.Phone) : "",
							carer2: carer2 && carer2.Phone ? carer2.Name : "",
							carer2_email: carer2 ? carer2.Email : "",
							carer2_phone: carer2 ? formatPhone(carer2.Phone) : "",
							approval: !item.Attending ? "" : item.Attending,
							approval_time: item.ApprovedAt
								? new Date(item.ApprovedAt).toLocaleDateString("en-au", {
										month: "short",
										day: "numeric",
										hour: "numeric",
										minute: "numeric",
								  })
								: "",
							form:
								item.FormsSubmitted &&
								typeof item.FormsSubmitted !== "undefined"
									? true
									: false,
							medical_form: medForm,
							dietary: (item.DietaryRequirements ?? "").trim(),
						};
					}
				);
				setAttendees(attendeeArray);
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [eventData]);

	useEffect(() => {
		enableInteractionButtons();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [eventData]);

	useEffect(() => {
		onValueChange(approvalArray);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [approvalArray]);

	useEffect(() => {
		onFormValueChange(formArray);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formArray]);

	return (
		<>
			<Container>
				<Row className="">
					<Col className="col-md-4">
						<h3> Attendees</h3>
					</Col>
					<Col className="col-md-8 float-right buttonContainer">
						{canEdit && <>
							<Button
								variant="primary"
								id="create-notice"
								size="sm"
								onClick={handleCreateNotice}
								className={!showInteractionButtons ? "no-click" : ""}
								title={
									!showInteractionButtons
										? "Event has passed. Cannot create notice"
										: ""
								}
							>
								Create Notice
							</Button>
							<Button
								variant="primary"
								id="send-app-notification"
								size="sm"
								onClick={handleShowNotificationModal}
								className={!showInteractionButtons ? "no-click" : ""}
								title={
									!showInteractionButtons
										? "Event has passed. Cannot send notification"
										: ""
								}
							>
								Send App Notification
							</Button>
						</>
						}

						<Dropdown align="end" className="d-inline-block">
							<Dropdown.Toggle
								id="dropdown-basic-button"
								variant="primary"
								size="sm"
								disabled={reportButtonDisabled && dietaryRows.length === 0}
							>
								Download Report
							</Dropdown.Toggle>
							{/* fixed positioning keeps the menu from being clipped by the page edge */}
							<Dropdown.Menu popperConfig={{ strategy: "fixed" }}>
								<Dropdown.Item
									href={pdfMedical}
									target="_blank"
									disabled={reportButtonDisabled}
								>
									Medical (pdf)
								</Dropdown.Item>
								<Dropdown.Item
									href={csvMedical}
									target="_blank"
									disabled={reportButtonDisabled}
								>
									Medical (csv)
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									type="button"
									disabled={dietaryRows.length === 0}
									onClick={handleDownloadDietary}
								>
									Dietary requirements (csv)
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col
						className="col-md-12 attendee-grid-container"
						style={{ height: 550, width: "100%" }}
					>
						<DataGrid
							rows={attendeeRows}
							columns={columns}
							hideFooterSelectedRowCount={true}
							onCellEditCommit={handleEditCell}
							components={{
								Toolbar: CustomToolbar,
							}}
							initialState={{
								sorting: {
									sortModel: [{ field: "surname", sort: "asc" }],
								},
							}}
						/>
					</Col>
				</Row>
				<EventNotifyModal
					show={showNotificationModal}
					groups={[eventData.ParentGroup]}
					onNotifySent={handleNotifySent}
					onCloseModal={handleCloseNotificationModal}
				/>
				{/* <EventToast
					delay={5000}
					title={"Event Manager"}
					message={"Notification sent"}
					show={showToast}
				/> */}
			</Container>
		</>
	);
};
